interface ChipProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
}

export function Chip({ label, active, onClick, onRemove }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'inline-flex h-9 items-center gap-1.5 rounded-full border px-3.5 text-sm font-medium transition-colors duration-200',
        active ? 'border-brand-500 bg-brand-500 text-white' : 'border-ink-200 bg-surface text-ink-600 hover:bg-ink-50',
      ].join(' ')}
    >
      {label}
      {onRemove && (
        <span
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-0.5"
        >
          ×
        </span>
      )}
    </button>
  );
}
